import ListagemFornecedor from '@/modules/gestao-fornecedor/ListagemFornecedor.vue';
import FornecedorDetalhes from '@/modules/gestao-fornecedor/gestao/detalhes/FornecedorDetalhes.vue';
import CadastroFornecedor from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedor.vue';

export default [
  {
    path: 'fornecedores',
    name: 'main.gestao-fornecedores.fornecedores',
    components: {
      default: ListagemFornecedor,
    },
  },
  {
    path: 'fornecedores/cadastro',
    name: 'main.gestao-fornecedores.cadastro-fornecedores',
    components: {
      default: CadastroFornecedor,
    },
  },
  {
    path: 'fornecedor/:id',
    name: 'main.gestao-fornecedores.fornecedor',
    components: {
      default: FornecedorDetalhes,
    },
    props: true,
  },
];
